import React from 'react';
import PanelSection from '../../FormElements/PanelSection';

export default class UserPersonalInfo extends React.Component {
	constructor(props) {
		super(props);

		const data = this.props.data || [];

		this.state = {
			data: data,
			isEditingName: false,
			isEditingEmail: false,
			isEmailNotifications: false
		};

		this.onChange = this.onChange.bind(this);
		this.onClickSaveName = this.onClickSaveName.bind(this);
		this.onClickEditName = this.onClickEditName.bind(this);
		this.onClickSaveEmail = this.onClickSaveEmail.bind(this);
		this.onClickEditEmail = this.onClickEditEmail.bind(this);
	}

	componentDidMount() {
		if (!this.state.data || this.state.data.length === 0) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.endpoint !== this.props.endpoint) {
			this.loadData();
		}
	}

	render() {
		// console.log(this.props)
		let section = null;

		if (this.state.data) {
			// console.log(this.state.data);
			section = (
				<div className="UserPersonalInfo">
					<PanelSection title={I18n.t('admin.user.basics-title')}>
						<div className="container">
							{this.state.isEditingName ? (
								<div className="data-group">
									<label htmlFor="name">{this.state.data.name_label}</label>
									<input
										type="text"
										id="name"
										name="Name"
										defaultValue={this.state.data.name_value}
										onChange={this.onChange}
									/>
									<button className="link" onClick={this.onClickSaveName}>
										Save
									</button>
									<button className="link" onClick={this.onClickSaveName}>
										Cancel
									</button>
								</div>
							) : (
								<div className="data-group">
									<label htmlFor="name">{this.state.data.name_label}</label>
									<p>{this.state.data.name_value}</p>
									<button className="link" onClick={this.onClickEditName}>
										Edit
									</button>
								</div>
							)}
							{this.state.isEditingEmail ? (
								<div className="data-group">
									<label htmlFor="email">{this.state.data.email_label}</label>
									<input
										type="text"
										id="email"
										name={this.state.data.email_label}
										defaultValue={this.state.data.email_value}
										onChange={this.onChange}
									/>
									<button className="link" onClick={this.onClickSaveEmail}>
										Save
									</button>
									<button className="link" onClick={this.onClickSaveEmail}>
										Cancel
									</button>
								</div>
							) : (
								<div className="data-group">
									<label htmlFor="name">{this.state.data.email_label}</label>
									<p>{this.state.data.email_value}</p>
									<button className="link" onClick={this.onClickEditEmail}>
										Edit
									</button>
								</div>
							)}
							<div className="data-group">
								<label htmlFor="status">{this.state.data.status_label}</label>
								<p>{this.state.data.status_value}</p>
							</div>
							<div className="data-group address-group">
								<label htmlFor="address">{this.state.data.address_label}</label>
								<p>{this.state.data.status_value}</p>
							</div>
							<div className="data-group">
								<label htmlFor="birthday">
									{this.state.data.birthday_label}
								</label>
								<p>{this.state.data.birthday_value}</p>
							</div>
						</div>
					</PanelSection>
				</div>
			);
		}

		return (
			<div>
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
				<div>{section}</div>
			</div>
		);
	}

	onChange(evt) {
		preventDefault();
		this.setState({
			[evt.target.name]: evt.target.value
		});
	}

	onClickSaveName() {
		this.setState({
			isEditingName: false
		});
	}
	onClickEditName() {
		this.setState({
			isEditingName: true
		});
	}
	onClickSaveEmail() {
		this.setState({
			isEditingEmail: false
		});
	}
	onClickEditEmail() {
		this.setState({
			isEditingEmail: true
		});
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'POST',
			url: this.props.endpoint
		}).done((data) => {
			//console.log('UserGeneral loadData done', data);
			this.setState({ data: data, loading: false });
		});
	}
}
